import {config as componentsConfig} from './Components';
import {config as genericConfig} from './Generic';
import {config as actionsConfig} from './Actions';

export default (labels) => [
	componentsConfig(labels),
	genericConfig(labels, 'open'),
	genericConfig(labels, 'assessed'),
	genericConfig(labels, 'total'),
	actionsConfig()
];
